import {
  getYandexAutorizationUser,
  GetYandexAutorizationUserDto,
} from "@src/entities/login/api/requests/getYandexAutorizationUser";
import { useMutation } from "@tanstack/react-query";

export const useGetYandexAutorizationUser = () => {
  const query = useMutation({
    mutationKey: ["exchangeYandexCode"],
    mutationFn: (data: GetYandexAutorizationUserDto) =>
      getYandexAutorizationUser(data),
  });

  return query;
};
